import { forwardRef } from "react";
import type { InputHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: ReactNode;
  containerClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ leadingIcon, className, containerClassName, ...props }, ref) {
  if (!leadingIcon) {
    return (
      <input
        className={cn(
          "h-9 w-full rounded-sm border border-border bg-surface-2 px-3 text-body text-text-primary placeholder:text-text-muted focus-visible:outline-2 focus-visible:outline-primary",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  }
  return (
    <span className={cn("relative flex items-center", containerClassName)}>
      <span className="pointer-events-none absolute left-3 flex text-text-muted">{leadingIcon}</span>
      <input
        className={cn(
          "h-9 w-full rounded-sm border border-border bg-surface-2 py-2 pl-9 pr-3 text-body text-text-primary placeholder:text-text-muted focus-visible:outline-2 focus-visible:outline-primary",
          className,
        )}
        ref={ref}
        {...props}
      />
    </span>
  );
});
